/* fallback */
@font-face {
  font-family: 'Material Symbols Sharp';
  font-style: normal;
  font-weight: 400;
  src: url(https://fonts.gstatic.com/s/materialsymbolssharp/v238/gNMyW2J8Roq16WD5tFNRaeLQk6-SHQ_R00k4c2_wjOOEa9ruReaU4bHmz4BC2dgEH-VBwaxx0TV08dDFHsF-H5uf1kw.woff2) format('woff2');
}

.material-symbols-sharp {
  font-family: 'Material Symbols Sharp';
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-feature-settings: 'liga';
  -webkit-font-smoothing: antialiased;
}
